/**
 * The predicate a custom report runs — one rule for the Report Designer and
 * its print page, so the two can never draw different rows for one report.
 *
 * The answer goes to useItemListData's `queryAst` argument; `undefined` there
 * means "use the filter builder's groups".
 *
 *   - The designer has a live statement bar. In statement mode its applied
 *     statement is the query (NOT and nesting included — the builder cannot
 *     show those, so drawing from the builder would draw the wrong rows). In
 *     builder mode the filters are the query.
 *   - The print page has no bar: the saved report's own statement is the query.
 */

import type { QueryNode } from './pql';
import type { SavedReport } from '../types/prioritization/savedReports';

export interface LiveStatement {
  mode: 'builder' | 'statement';
  appliedAst: QueryNode | null;
}

export function customReportQueryAst(
  live: LiveStatement | null,
  report?: Pick<SavedReport, 'queryAst'>,
): QueryNode | null | undefined {
  if (live) return live.mode === 'statement' ? live.appliedAst : undefined;
  return report?.queryAst ?? undefined;
}
